import { gsap } from 'gsap'
import { ScrollSmoother } from 'gsap/ScrollSmoother'
import { ScrollTrigger } from 'gsap/ScrollTrigger'


gsap.registerPlugin(ScrollSmoother);
gsap.registerPlugin(ScrollTrigger);

let smoothScroll

let smoothScrollEffects = true
if (window.innerWidth < 1200) smoothScrollEffects = false
let smoothScrollParams = {
  normalizeScroll: true,
  smooth: 1.5,   // seconds it takes to "catch up" to native scroll position
  effects: smoothScrollEffects // look for data-speed and data-lag attributes on elements and animate accordingly
}

if (typeof ScrollSmoother === 'function') {

  smoothScroll = ScrollSmoother.create(smoothScrollParams);

  $(window).scroll(function () {
    let footer = $('footer')

    let footerTop = footer.offset().top - $(window).height() - 200
    let top = $(window).scrollTop()

    if (top > footerTop) {
      if (!footer.hasClass('js-smooth-recalculated')) {
        ScrollTrigger.refresh()
        footer.addClass('js-smooth-recalculated')
      }
    } else {
      footer.removeClass('js-smooth-recalculated')
    }

  })


  // init other functions which need smooth scroll

}

export function smoothScrollPause(){
  smoothScroll.paused(true)
}
export function smoothScrollPlay(){
  smoothScroll.paused(false)
}
export function updateSmoothScroll(){
  ScrollTrigger.refresh()
}
export function smoothScrollKill(){
  smoothScroll.kill()
}
export function smoothScrollCreate(){
  smoothScroll = ScrollSmoother.create(smoothScrollParams);
}

// ScrollTrigger.create({
//   trigger: ".box-c",
//   pin: true,
//   start: "center center",
//   end: "+=300"
// });

// document.querySelector("button").addEventListener("click", e => {
//   // scroll to the spot where .box-c is in the center.
//   // parameters: element, smooth, position
//   smoother.scrollTo(".box-c", true, "center center");
//
//   // or you could animate the scrollTop:
//   // gsap.to(smoother, {
//   //  scrollTop: smoother.offset(".box-c", "center center"),
//   //  duration: 1
//   // });
// });
